import React, { useMemo, useState } from 'react';
import NextLink from 'next/link';

import * as ST from './styled';

type valuesProps = {
    title: string,
    url?: string,
};

type districtsProps = {
    key: string,
    values: valuesProps[],
};

type AddressListProps = {
    districts: districtsProps[],
};

const AddressList: React.FC<AddressListProps> = ({ districts }) => {
    const [addressListTitle] = useState('Или выберите свой район');

    const filteredDistricts = useMemo(() => {
        return districts.reduce((acc: any, el: any) => {
            if (el) {
                return [...acc, {
                    title: el.key,
                }, ...el.values];
                }
            return acc;
        }, []);
    }, [districts]);

    return (
        <ST.AddressList className={'ym-hide-content'}>
            <ST.AddressListTitle>{addressListTitle}</ST.AddressListTitle>
            <ST.AddressBlockWrapper>
                {filteredDistricts.map((item: valuesProps) => (
                    <ST.AddressBlockLinks key={item.title} >
                        {!item.url
                            ? (
                                <ST.AddressBlockKey>
                                    {item.title}
                                </ST.AddressBlockKey>
                            )
                            : (
                                <NextLink href={`/request/address/${item.url}`} passHref>
                                    <ST.LinkTitle>{item.title}</ST.LinkTitle>
                                </NextLink>
                        )}
                    </ST.AddressBlockLinks>
                ))}
            </ST.AddressBlockWrapper>
        </ST.AddressList>
    );
};

export default AddressList;
